export default __webpack_public_path__ + "static/media/circleHalfTp.3db92f80.svg";